import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Ui::MaintenancePage />\n",{ moduleName: "uplisting-frontend/pods/error/template.hbs" })